import client from "../Client/HttpClient";
import { ISystemAreasModel } from "@/interfaces/modules";

const ApiPath = "SystemAreas";

export default {
  GetAreas: (): Promise<ISystemAreasModel[]> => client.get(`${ApiPath}`),
  GetAreaById: (data: ISystemAreasModel): Promise<ISystemAreasModel> =>
    client.get(`${ApiPath}/${data.Id}`),
  PostArea: (data: ISystemAreasModel): Promise<ISystemAreasModel> =>
    client.post(`${ApiPath}`, data),
};

